import {activityTypes} from "@/json/activityTypes";

export default function ActivityTypeTag({typeId}){
    const activityType = activityTypes.find(el => el.id === typeId);
    return(
        <div className={`py-1 px-3 rounded font-semibold text-sm text-white bg-primary `}>
            {activityType.value}
        </div>
    )
}